// Full language catalogue. en/bn/hi are hand-written; the rest come from uiGenerated.js.
export const LANGUAGES = [
  { code: "en", label: "English", native: "English", short: "EN", group: "Primary" },
  { code: "bn", label: "Bengali", native: "বাংলা", short: "BN", group: "Primary" },
  { code: "hi", label: "Hindi", native: "हिन्दी", short: "HI", group: "Primary" },
  { code: "as", label: "Assamese", native: "অসমীয়া", short: "AS", group: "India" },
  { code: "or", label: "Odia", native: "ଓଡ଼ିଆ", short: "OR", group: "India" },
  { code: "ne", label: "Nepali", native: "नेपाली", short: "NE", group: "India" },
  { code: "mr", label: "Marathi", native: "मराठी", short: "MR", group: "India" },
  { code: "gu", label: "Gujarati", native: "ગુજરાતી", short: "GU", group: "India" },
  { code: "pa", label: "Punjabi", native: "ਪੰਜਾਬੀ", short: "PA", group: "India" },
  { code: "ta", label: "Tamil", native: "தமிழ்", short: "TA", group: "India" },
  { code: "te", label: "Telugu", native: "తెలుగు", short: "TE", group: "India" },
  { code: "kn", label: "Kannada", native: "ಕನ್ನಡ", short: "KN", group: "India" },
  { code: "ml", label: "Malayalam", native: "മലയാളം", short: "ML", group: "India" },
  { code: "ur", label: "Urdu", native: "اردو", short: "UR", group: "India", rtl: true },
  { code: "es", label: "Spanish", native: "Español", short: "ES", group: "World" },
  { code: "fr", label: "French", native: "Français", short: "FR", group: "World" },
];

export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const getLanguage = (code) => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
